import { purify } from "../_src/components/purify";
import { modalOpenBtnPodcast } from "../acervo-digital";
import * as modal from "../modal/index";


export function loadMorePodcasts() {
    var btnLoadMore = document.querySelector("[data-action=load-more-agro-podcasts]")

    function loadMore(loadMore) {
        var form = document.querySelector('#filter-podcasts');
        var data = new FormData(form);

        btnLoadMore ? btnLoadMore.classList.add("loading") : ''

        if (!loadMore) {
            document.querySelector("#result-agro-podcasts").innerHTML = ''
            document.querySelector(".loader-podcasts").classList.remove("hidden")
        }

        document.querySelectorAll("#filter-podcasts fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        var pagina = loadMore ? btnLoadMore.getAttribute("data-page") : 1;

        fetch(`/agro-tv/ajax/podcast.html/p${pagina}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-agro-podcasts").insertAdjacentHTML('beforebegin', response);

                if ( parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.totalpages)) {
                    btnLoadMore.remove()
                }

            } else {
                document.querySelector("#result-agro-podcasts").innerHTML = purify(response);
                loadMorePodcasts();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            modalOpenBtnPodcast();

            if (!loadMore) {
                document.querySelector(".loader-podcasts").classList.add("hidden")
            }

            btnLoadMore ? btnLoadMore.classList.remove("loading") : ''

            document.querySelectorAll("#filter-podcasts fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })
        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { loadMore(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
    }

    document.querySelector("#filter-podcasts").addEventListener("submit", function(event) { event.preventDefault(), loadMore(false), btnLoadMore ? btnLoadMore.dataset.page = "1" : "1" }, false);
}

export function searchAndLoadMoreVideos() {
    var btnLoadMore = document.querySelector("[data-action=load-more-agro-videos]")

    function loadMoreVideo(loadMore) {
        var form = document.querySelector('#filter-videos');
        var data = new FormData(form);
        const ifagPage = document.querySelector(".ifag__videos__container");
        const customClass = ifagPage ? "ifag" : ""

        btnLoadMore ? btnLoadMore.classList.add("loading") : ''

        if (!loadMore) {
            document.querySelector("#result-agro-videos").innerHTML = ''
            document.querySelector(".loader-videos").classList.remove("hidden")
        }

        document.querySelectorAll("#filter-videos fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        var pagina = loadMore ? btnLoadMore.getAttribute("data-page") : 1;

        const url = ifagPage ? "ifagPortal/videos" : "/agro-tv"
        fetch(`${url}/ajax/videos.html/p${pagina}?&loadmore=${loadMore}&customClass=${customClass}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-agro-videos").insertAdjacentHTML('beforebegin', response);

                if ( parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.totalpages)) {
                    btnLoadMore.remove()
                }

            } else {
                document.querySelector("#result-agro-videos").innerHTML = purify(response);
                searchAndLoadMoreVideos();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {

            if (!loadMore) {
                document.querySelector(".loader-videos").classList.add("hidden")
            }

            modal.modalVideo();

            btnLoadMore ? btnLoadMore.classList.remove("loading") : ''

            document.querySelectorAll("#filter-videos fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })
        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { loadMoreVideo(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
    }

    document.querySelector("#filter-videos").addEventListener("submit", function(event) { event.preventDefault(), loadMoreVideo(false), btnLoadMore ? btnLoadMore.dataset.page = "1" : "1" }, false);

    const clearBtnVideos = document.querySelector('#filter-videos [data-action=clear-search]')
    if (clearBtnVideos) {
        clearBtnVideos.disabled = true;
        const termInput = document.querySelector('#filter-videos input[name="term"]');

        function updateClearBtnVideos() {
            const hasText = termInput && termInput.value.trim().length > 0;
            const hasActiveFilter = document.querySelector('#data').value !== "";
            clearBtnVideos.disabled = !(hasText || hasActiveFilter);
        }
        
        clearBtnVideos.addEventListener("click", function () {
            if (termInput) termInput.value = "";
            document.querySelector('#data').value = "";
            document.querySelector("#result-agro-videos").innerHTML = "";
            document.querySelector(".loader-videos").classList.remove("hidden");
            updateClearBtnVideos();

            if(btnLoadMore) btnLoadMore.dataset.page = "1";
            loadMoreVideo(false);
        });

        if (termInput) termInput.addEventListener("input", updateClearBtnVideos);
        updateClearBtnVideos();
    }
}

if (document.querySelector("#filter-podcasts")) {
    loadMorePodcasts();
}

if (document.querySelector("#filter-videos")) {
    searchAndLoadMoreVideos();
}
